<template>
  <div id="app">

    <div class="toolbar" v-if="displayState !== EDisplayState.Loading && displayState !== EDisplayState.Error">
      <a href="https://eviglance.com">
        <img id="logo" src="@/assets/evi-logo.png">
      </a>
      <h2>{{ mapStore.state.map.title }}</h2>
      <Search/>
      <div class="spacer"></div>
      <div class="btn" v-if="displayState === EDisplayState.Tabular"
           @click="e => displayState = EDisplayState.Ggraph"
      >
        go to MAP display
      </div>
      <div class="btn" v-else
           @click="e => displayState = EDisplayState.Tabular"
      >
        go to TABULAR display
      </div>
      <div id="home-button" @click="_ => mapStore.reset()">
        <i class="fas fa-home"/>
      </div>
    </div>
    <Loading v-if="displayState === EDisplayState.Loading"/>
    <div class="toolbar error" v-if="displayState === EDisplayState.Error">Error while Fetching data, please reload or
      contact the admin
    </div>
    <GraphView v-else-if="displayState === EDisplayState.Ggraph"
               @mode:tabular="e => displayState = EDisplayState.Tabular"/>
    <TabularView v-else-if="displayState === EDisplayState.Tabular"
                 @mode:graph="e => displayState = EDisplayState.Ggraph"/>
  </div>
</template>
<script lang="ts">
import {defineComponent, onMounted, provide, ref} from "vue"
import {fetchMap, createMapStore, fetchEviglance} from "@/mixins/mapStore";
import Loading from "@/components/Loading.vue";
import GraphView from "@/views/GraphView.vue";
import TabularView from "@/views/TabularView.vue";
import Search from "@/components/Search.vue";

enum EDisplayState {
  Select, Loading, Ggraph, Tabular, Error
}

export default defineComponent({
  name: "app",
  components: { Search, GraphView, Loading, TabularView},
  setup() {
    const displayState = ref(EDisplayState.Loading)
    const selectMap = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const l_Map = await fetchMap(urlParams.get("map"))
        const l_Eviglance = await fetchEviglance();

        // console.log(l_Map)
        // console.log(l_Eviglance)
        mapStore.state.map = l_Map
        mapStore.state.about = l_Eviglance["about"]
        mapStore.state.instructionsMap= l_Eviglance["instructionPathWebMap"]
        mapStore.state.instructionsTabular= l_Eviglance["instructionPathWebTab"]
        displayState.value = EDisplayState.Ggraph;
      } catch (e) {
        console.log(e)
        displayState.value = EDisplayState.Error
      }
    }
    const mapStore = createMapStore();
    provide("mapStore", mapStore)
    selectMap()
    return {
      displayState,
      EDisplayState,
      mapStore
    }
  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

#app {
  height: 100%;

  #logo{
    height: 3.5vh;
    margin-right: 1vw;
  }
  #home-button {
    width: 5vh;
    height: 5vh;
    line-height: 5vh;
    text-align: center;
    cursor: pointer;
    i {
      color: white;
      font-size: 2vh;
    }
    &:hover {
      i {
        color: $accent;
      }
    }
  }
  .toolbar {
    height: 5vh;
    background-color: $primary;
    display: flex;
    padding: 0 0 0$default-padding ;
    align-items: center;

    &.error {
      background-color: red;
      color: white;
      font-weight: bold;
    }

    //justify-content: center;

    h2 {
      color: white;
      margin-right: 1vw;
      margin-bottom: 0;
    }
  }
}

</style>
